import InvoiceDetails from "../../components/admin/generated-invoice/invoice-details";

const InvoiceDetailsPage = () => {
  return (
    <InvoiceDetails />
  );
};

export default InvoiceDetailsPage;